import React from 'react';

export type FullscreenContextOptions = {
  fullscreen: boolean;
  maximize: () => void;
  restore: () => void;
  /** Fullscreen is controlled by the embedding page: no fullscreen controls are shown. */
  locked?: boolean;
};

export const FullscreenContext = React.createContext<FullscreenContextOptions>({
  fullscreen: false,
  maximize: () => undefined,
  restore: () => undefined,
});

export const GlobalFullscreenContext = React.createContext<FullscreenContextOptions>({
  fullscreen: false,
  maximize: () => undefined,
  restore: () => undefined,
});
